export const Announcements = "最新優惠：雙人房優惠價1200元，四人房1800元。詳情歡迎電0983-661588。民宿有收五倍券，歡迎使用。各種房型說明請點客房介紹。"
